import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray, useField } from "formik";
import FormData from "form-data";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getBank } from "../../../store/bank/action";
import { resetAgencyState, getAgency as onGetAgencys, addNewAgency as onAddNewAgency, updateAgency as onUpdateAgency, deleteAgency as onDeleteAgency, getAgencyLoading } from "../../../store/agency/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import ExportDoc from "../../../Components/Common/ExportDoc";

const Agency = (props) => {
  const [placeDefaultVal, setPlaceDefaultVal] = useState("");
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [isDisabledUserType, setIsDisabledUserType] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [logo, setLogo] = useState(defaultImg);
  const [modalMedia, setModalMedia] = useState(false);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, agencys, isAgencyCreated, isAgencySuccess, loading, error, companies, companyLoading, clients, clientLoading, banks, bankLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    agencys: state.Agency.agencys,
    loading: state.Agency.loading,
    isAgencyCreated: state.Agency.isAgencyCreated,
    isAgencySuccess: state.Agency.isAgencySuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    banks: state.Bank.banks,
    bankLoading: state.Bank.loading,
    error: state.Agency.error,
  }));

  const [agencyList, setAgencyList] = useState([]);
  const [agencyDoc, setAgencyDoc] = useState([]);
  const [agency, setAgency] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [agencyContactItem, setAgencyContactItem] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [bankList, setBankList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [positionMessage, setPositionMessage] = useState("");
  const [printDoc, setPrintDoc] = useState([]);

  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen(open);
    } else {
      setOpen(id);
    }
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Code",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "Telepon",
        isSelected: true,
        data: [],
      },
      {
        id: "email",
        label: "Email",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "agency_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "agency_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (agencyList.length > 0) {
      agencyList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "agency_client" || doc.id === "agency_client" || doc.id === "agency_agency") {
                doc.data.push(value?.name ?? "");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setAgencyDoc(dataDoc);
  }, [agencyList]);

  const onClickDelete = (agency) => {
    setAgency(agency);
    setDeleteModal(true);
  };

  const onClickApprove = (agency) => {
    setAgency(agency);
    setApproveModal(true);
  };

  const handleDeleteAgency = () => {
    if (agency) {
      dispatch(onDeleteAgency(agency));
      setDeleteModal(false);
    }
  };

  const handleApproveAgency = () => {
    if (agency) {
      agency.setApprove = true;
      dispatch(onUpdateAgency(agency));
      setApproveModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    dispatch(resetAgencyState());
    dispatch(onGetAgencys());
  }, []);

  useEffect(() => {
    if (!isEmpty(agencys)) {
      let filteredAgencys = agencys;
      if (activeTypeTab !== "all") {
        filteredAgencys = agencys.filter((agency) => agency.agency_status.name === activeTypeTab);
      }
      setAgencyList(filteredAgencys);
      setInfo(agencys[agencys.length - 1]);
      setIsEdit(false);
    }
  }, [agencys]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      default:
        setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAgencys = agencys;
      if (type !== "all") {
        filteredAgencys = agencys.filter((agency) => agency.agency_status.name === type);
      }
      setAgencyList(filteredAgencys.map((el) => ({ ...el, isChecked: false })));
    }
  };

  useEffect(() => {
    if (banks && !banks.length) {
      dispatch(getBank());
    }
  }, [dispatch, banks]);

  useEffect(() => {
    if (!isEmpty(banks)) {
      var data = [];
      var opt = [];
      banks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBankList(data);
    }
  }, [banks]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAgency(null);
      setAgencyContactItem([]);
      setCompanyList([]);
      setPlaceDefaultVal("");
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleGetCompany = useCallback(
    (id) => {
      dispatch(resetCompanyState());
      dispatch(getCompany({ clientId: id }));
    },
    [dispatch],
  );

  const handleAgencyClick = useCallback(
    (arg) => {
      const agency = arg;
      let venaddress = [];
      let venbank = [];
      let venagency = [];
      agency.agency_address.forEach((address) => {
        if (address.isPrimary) venaddress = address;
      });
      const addressName = venaddress ? venaddress.address_name : "";
      const addressLabel = venaddress ? venaddress.description : "";
      const addressValue = venaddress ? venaddress.villageId : "";

      let address_agency = {};
      for (const address of agency.agency_address) {
        if (address.isPrimary) {
          address_agency = address;
        }
      }

      agency.agency_bank.forEach((bank) => {
        if (bank.isPrimary) venbank = bank;
      });

      if (agency.agency_contact) {
        agency.agency_contact.forEach((element) => {
          venagency.push({
            id: element.id,
            name: element.name,
            email: element.email,
            phone: element.phone,
            position: element.position,
          });
        });
        setAgencyContactItem(venagency);
      }

      setPlaceDefaultVal({
        label: `${address_agency.village} ${address_agency.district} ${address_agency.city} ${address_agency.province} ${address_agency.country}`,
        value: `${address_agency.village} ${address_agency.district} ${address_agency.city} ${address_agency.province} ${address_agency.country}`,
      });

      setAgency({
        id: agency.id,
        idBank: venbank.id ?? 0,
        address: {
          label: `${address_agency.village} ${address_agency.district} ${address_agency.city} ${address_agency.province} ${address_agency.country}`,
          value: `${address_agency.village} ${address_agency.district} ${address_agency.city} ${address_agency.province} ${address_agency.country}`,
        },
        street: address_agency.description ?? "",
        zip: address_agency.code ?? "",
        village: address_agency.village ?? "",
        district: address_agency.district ?? "",
        city: address_agency.city ?? "",
        province: address_agency.province ?? "",
        country: address_agency.country ?? "",
        name: agency.name,
        email: agency.email,
        password: agency.agency_user ? agency.agency_user.pass : "",
        phone: agency.phone,
        fax: agency.fax,
        image: agency.image,
        tax_number: agency.tax_number,
        website: agency.website,
        description: agency.description,
        number: venbank.number,
        bank: venbank.bank_data_bank && {
          label: venbank.bank_data_bank.name,
          value: venbank.id,
        },
        agency_status: {
          label: agency.agency_status.name,
          value: agency.agency_status.id,
        },

        agency_contact: venagency,
        client: agency.agency_client && {
          label: agency.agency_client ? agency.agency_client.name : "",
          value: agency.agency_client ? agency.agency_client.id : "",
        },
        company: agency.agency_company && {
          label: agency.agency_company ? agency.agency_company.name : "",
          value: agency.agency_company ? agency.agency_company.id : "",
        },
        instagram: agency.social_media.instagram,
        facebook: agency.social_media.facebook,
        tiktok: agency.social_media.tiktok,
        youtube: agency.social_media.youtube,
        twitter: agency.social_media.twitter,
      });

      handleGetCompany(agency.agency_client.id);

      switch (userType) {
        case "admin":
          setIsDisabledUserType(false);
          break;

        default:
          if (userType === "client") {
            handleGetCompany(agency.agency_client ? agency.agency_client.id : "");
          }
          setIsDisabledUserType(true);
          break;
      }

      setIsEdit(true);
      toggle();
    },
    [toggle, userType, handleGetCompany],
  );

  //  {
  //       id: "#Phone",
  //       Header: "Telepon",
  //       accessor: "phone",
  //       filterable: true,
  //     },
  //     {
  //       id: "#Email",
  //       Header: "Email",
  //       accessor: "email",
  //       filterable: true,
  //     },
  //     {
  //       id: "#Website",
  //       Header: "Website",
  //       accessor: "website",
  //       filterable: true,
  //     },
  //     {
  //       id: "#Status",
  //       Header: "Status",
  //       accessor: "agency_status.name",
  //       filterable: true,
  //       Cell: (cell) => {
  //         switch (cell.value) {
  //           case "DRAFT":
  //             return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
  //           case "ACTIVE":
  //             return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
  //           case "INACTIVE":
  //             return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
  //           default:
  //             return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
  //         }
  //       },
  //     },

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "phone",
        label: "Telepon",
        isSelected: true,
        data: [],
      },
      {
        id: "email",
        label: "Email",
        isSelected: true,
        data: [],
      },
      {
        id: "website",
        label: "Website",
        isSelected: true,
        data: [],
      },
      {
        id: "agency_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (agencyList.length > 0) {
      agencyList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "agency_status") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [agencyList]);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = agencyList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAgencyList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = agencyList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAgencyList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAgency") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAgencyClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAgency") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {cellProps.row.original.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : userRole && userRole.split(",").indexOf("approveAgency") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : "btn-label btn btn-sm btn-soft-success fs-12 ms-2 d-none"}
                  onClick={() => {
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        id: "#Name",
        Header: "Nama",
        filterable: true,
        accessor: "name",
        Cell: (agency) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0">
                {agency.row.original.image ? (
                  <img src={agency.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${agency.row.original.image}`} alt="" className="avatar-xs rounded-circle me-1" />
                ) : (
                  <div className="flex-shrink-0 avatar-xs me-1">
                    <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{agency.row.original.name.charAt(0)}</div>
                  </div>
                )}
              </div>
              <div className="flex-grow-1 ms-2 name">{agency.row.original.name}</div>
            </div>
          </>
        ),
      },
      {
        id: "#Phone",
        Header: "Telepon",
        accessor: "phone",
        filterable: true,
      },
      {
        id: "#Email",
        Header: "Email",
        accessor: "email",
        filterable: true,
      },
      {
        id: "#Website",
        Header: "Website",
        accessor: "website",
        filterable: true,
      },
      {
        id: "#Status",
        Header: "Status",
        accessor: "agency_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [agencyList, handleAgencyClick, logo, userType, userRole, isCheckAll],
  );

  const onChange = useAsyncDebounce((value) => {
    const resetChecked = agencyList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAgencyList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
  }, 600);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: agencyList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAgencys(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAgencyList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    dispatch(resetAgencyState());
    dispatch(onGetAgencys());
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      company: (agency && agency.company) || companySelected,
      client: (agency && agency.client) || clientSelected,
      name: (agency && agency.name) ?? "",
      email: (agency && agency.email) ?? "",
      password: (agency && agency.password) ?? "",
      phone: (agency && agency.phone) ?? "",
      birthat: (agency && agency.birthat) ?? "",
      fax: (agency && agency.fax) ?? "",
      tax_number: (agency && agency.tax_number) ?? "",
      number: (agency && agency.number) ?? "",
      website: (agency && agency.website) ?? "",
      description: (agency && agency.description) ?? "",
      address: (agency && agency.address) ?? "",
      agencies_status: agency && agency.agencies_status,
      village: agency && agency.village,
      bank: (agency && agency.bank) ?? "",
      idBank: (agency && agency.idBank) || 0,
      zip: (agency && agency.zip) ?? "",
      street: (agency && agency.street) ?? "",
      image: (agency && agency.image) ?? "",
      instagram: (agency && agency.instagram) ?? "",
      facebook: (agency && agency.facebook) ?? "",
      tiktok: (agency && agency.tiktok) ?? "",
      youtube: (agency && agency.youtube) ?? "",
      twitter: (agency && agency.twitter) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Agency Name").nullable(true),
      phone: Yup.string().required("Please Enter Phone Number").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getAgencyLoading());
      if (isEdit) {
        let editDataSubmit = {
          id: agency.id,
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          description: values.description,
          zip: values.zip,
          village: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[0].value : agency.village,
          district: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 4].value : agency.district,
          city: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 3].value : agency.city,
          province: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 2].value : agency.province,
          country: typeof values.address.value === "object" && values.address.value.terms ? values.address.value.terms[values.address.value.terms.length - 1].value : agency.country,
          street: values.street,
          agency_contact: JSON.stringify(agencyContactItem),
          image: values.image,
          social_media: {
            instagram: values.instagram,
            facebook: values.facebook,
            tiktok: values.tiktok,
            youtube: values.youtube,
            twitter: values.twitter,
          },
        };
        dispatch(onUpdateAgency(editDataSubmit));
      } else {
        let addDataSubmit = {
          clientId: values.client.value,
          companyId: values.company.value,
          name: values.name,
          email: values.email,
          password: values.password,
          phone: values.phone,
          fax: values.fax,
          tax_number: values.tax_number,
          website: values.website,
          idBank: values.idBank,
          bankId: values.bank.value,
          number: values.number,
          description: values.description,
          zip: values.zip,
          village: values.address.value && values.address.value.terms[0].value,
          district: values.address.value && values.address.value.terms[values.address.value.terms.length - 4].value,
          city: values.address.value && values.address.value.terms[values.address.value.terms.length - 3].value,
          province: values.address.value && values.address.value.terms[values.address.value.terms.length - 2].value,
          country: values.address.value && values.address.value.terms[values.address.value.terms.length - 1].value,
          street: values.street,
          agency_contact: JSON.stringify(agencyContactItem),
          image: values.image,
          social_media: {
            instagram: values.instagram,
            facebook: values.facebook,
            tiktok: values.tiktok,
            youtube: values.youtube,
            twitter: values.twitter,
          },
        };
        dispatch(onAddNewAgency(addDataSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  function handleAgencyContactAdd() {
    let fc = [];
    if (agencyContactItem && agencyContactItem.length) {
      agencyContactItem.forEach((element) => {
        fc.push(element);
      });
    }

    fc.push({
      name: "",
      email: "",
      phone: "",
    });
    setAgencyContactItem(fc);
  }

  // const checkedAll = () => {
  //   const checkall = document.getElementById("checkBoxAll");
  //   const ele = document.querySelectorAll(".dataCheckbox");

  //   if (checkall.checked) {
  //     ele.forEach((ele) => {
  //       ele.checked = true;
  //     });
  //   } else {
  //     ele.forEach((ele) => {
  //       ele.checked = false;
  //     });
  //   }
  // };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAgency(element.value));
    });
    checkall.checked = false;
  };

  document.title = "Mitra | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={agencyList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAgency} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={agency && agency.name ? agency.name : ""} show={approveModal} onApproveClick={handleApproveAgency} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Sales dan Konsumen" pageTitle="Mitra" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAgency") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-group-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <ExportDoc data={agencyDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger ms-1 add-btn" : userRole && userRole.split(",").indexOf("deleteAgency") !== -1 ? "btn btn-soft-danger ms-1 add-btn" : "btn btn-soft-danger ms-1 add-btn d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-group-line me-1 align-bottom fs-14"></i>SEMUA MITRA
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Mitra" : "Tambah Mitra"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="agencyname-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="agencyname-field" className="form-control" placeholder="Isi Nama Agensi" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="password-field" className="form-label">
                              Password <span className="text-danger">*</span>
                            </Label>
                            <Input name="password" id="password-field" className="form-control" placeholder="Isi Password" type="password" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.password ?? ""} invalid={validation.touched.password && validation.errors.password ? true : false} />
                            {validation.touched.password && validation.errors.password ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.password}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="phone-field" className="form-label">
                              Telepon{" "}
                            </Label>
                            <Input name="phone" id="phone-field" className="form-control" placeholder="Isi No. Telepon" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.phone ?? ""} invalid={validation.touched.phone && validation.errors.phone ? true : false} />
                            {validation.touched.phone && validation.errors.phone ? <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="website-field" className="form-label">
                              Website{" "}
                            </Label>
                            <Input name="website" id="website-field" className="form-control" placeholder="Isi Website" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.website ?? ""} invalid={validation.touched.website && validation.errors.website ? true : false} />
                            {validation.touched.website && validation.errors.website ? <FormFeedback type="invalid">{validation.errors.website}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="email-field" className="form-label">
                              Email{" "}
                            </Label>
                            <Input name="email" id="email-field" className="form-control" placeholder="Isi Email" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.email ?? ""} invalid={validation.touched.email && validation.errors.email ? true : false} />
                            {validation.touched.email && validation.errors.email ? <FormFeedback type="invalid">{validation.errors.email}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="fax-field" className="form-label">
                              Fax
                            </Label>
                            <Input name="fax" id="fax-field" className="form-control" placeholder="Isi Fax" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.fax ?? ""} invalid={validation.touched.fax && validation.errors.fax ? true : false} />
                            {validation.touched.fax && validation.errors.fax ? <FormFeedback type="invalid">{validation.errors.fax}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="instagram-field" className="form-label">
                              Instagram
                            </Label>
                            <Input name="instagram" id="instagram-field" className="form-control" placeholder="Isi Instagram" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.instagram ?? ""} invalid={validation.touched.instagram && validation.errors.instagram ? true : false} />
                            {validation.touched.instagram && validation.errors.instagram ? <FormFeedback type="invalid">{validation.errors.instagram}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="facebook-field" className="form-label">
                              Facebook
                            </Label>
                            <Input name="facebook" id="facebook-field" className="form-control" placeholder="Isi Facebook" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.facebook ?? ""} invalid={validation.touched.facebook && validation.errors.facebook ? true : false} />
                            {validation.touched.facebook && validation.errors.facebook ? <FormFeedback type="invalid">{validation.errors.facebook}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="instagram-field" className="form-label">
                              Tiktok
                            </Label>
                            <Input name="tiktok" id="tiktok-field" className="form-control" placeholder="Isi Tiktok" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tiktok ?? ""} invalid={validation.touched.tiktok && validation.errors.tiktok ? true : false} />
                            {validation.touched.tiktok && validation.errors.tiktok ? <FormFeedback type="invalid">{validation.errors.tiktok}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="facebook-field" className="form-label">
                              Youtube
                            </Label>
                            <Input name="youtube" id="youtube-field" className="form-control" placeholder="Isi Youtube" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.youtube ?? ""} invalid={validation.touched.youtube && validation.errors.youtube ? true : false} />
                            {validation.touched.youtube && validation.errors.youtube ? <FormFeedback type="invalid">{validation.errors.youtube}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="instagram-field" className="form-label">
                              Twiter
                            </Label>
                            <Input name="twitter" id="twitter-field" className="form-control" placeholder="Isi Twitter" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.twitter ?? ""} invalid={validation.touched.twitter && validation.errors.twitter ? true : false} />
                            {validation.touched.twitter && validation.errors.twitter ? <FormFeedback type="invalid">{validation.errors.twitter}</FormFeedback> : null}
                          </div>
                          <div className=" mb-3">
                            <Label htmlFor="bank-field" className="form-label">
                              Bank{" "}
                            </Label>
                            <Select
                              name="bank"
                              value={validation.values.bank}
                              placeholder="Pilih Bank"
                              onChange={(e) => {
                                validation.setFieldValue("bank", e);
                              }}
                              options={bankList}
                            ></Select>
                            {validation.touched.bank && validation.errors.bank ? (
                              <small className="text-danger" type="invalid">
                                {validation.errors.bank}
                              </small>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="number-field" className="form-label">
                              No. Rekening Bank{" "}
                            </Label>
                            <Input name="number" id="number-field" className="form-control" placeholder="Isi No. Rekening" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.number ?? ""} invalid={validation.touched.number && validation.errors.number ? true : false} />
                            {validation.touched.number && validation.errors.number ? <FormFeedback type="invalid">{validation.errors.number}</FormFeedback> : null}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <Label htmlFor="tax_number-field" className="form-label">
                              No. Pajak
                            </Label>
                            <Input name="tax_number" id="tax_number-field" className="form-control" placeholder="Isi No. Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.tax_number ?? ""} invalid={validation.touched.tax_number && validation.errors.tax_number ? true : false} />
                            {validation.touched.tax_number && validation.errors.tax_number ? <FormFeedback type="invalid">{validation.errors.tax_number}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 d-none">
                            <Label htmlFor="des-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="street-field" className="form-label">
                              Alamat
                            </Label>
                            <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street} invalid={validation.touched.street && validation.errors.street ? true : false} />
                            {validation.touched.street && validation.errors.street ? <FormFeedback type="invalid">{validation.errors.street}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="zip-field" className="form-label">
                              {props.t("zip Code")}{" "}
                            </Label>
                            <Input name="zip" id="zip-field" className="form-control" placeholder="Isi Kode Pos" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.zip ?? ""} invalid={validation.touched.zip && validation.errors.zip ? true : false} />
                            {validation.touched.zip && validation.errors.zip ? <FormFeedback type="invalid">{validation.errors.zip}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan (optional)
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} invalid={validation.touched.description && validation.errors.description ? true : false} />
                            {validation.touched.description && validation.errors.description ? <FormFeedback type="invalid">{validation.errors.description}</FormFeedback> : null}
                          </div>
                          <div className="mb-3 position-relative">
                            <Label htmlFor="agencies_contact" className="form-label">
                              Kontak Mitra
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                handleAgencyContactAdd();
                              }}
                            >
                              <i className="ri-add-line label-icon align-middle fs-16 me-1"></i> Tambah
                            </button>
                          </div>
                          {agencyContactItem.map((o, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3 d-flex gap-3 align-items-center">
                                <div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Nama{" "}
                                      </Label>
                                      <Input
                                        name={`agencyContactItem.${i}.name`}
                                        className="form-control"
                                        placeholder="Isi Nama"
                                        type="text"
                                        value={agencyContactItem[i].name ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agencyContactItem.${i}.name`, e.target.value);
                                          agencyContactItem[i].name = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Telepon
                                      </Label>
                                      <Input
                                        name={`agencyContactItem.${i}.phone`}
                                        className="form-control"
                                        placeholder="Isi No. Telepon"
                                        type="text"
                                        value={agencyContactItem[i].phone ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agencyContactItem.${i}.phone`, e.target.value);
                                          agencyContactItem[i].phone = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Email{" "}
                                      </Label>
                                      <Input
                                        name={`agencyContactItem.${i}.email`}
                                        className="form-control"
                                        placeholder="Isi Email"
                                        type="text"
                                        value={agencyContactItem[i].email ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agencyContactItem.${i}.email`, e.target.value);
                                          agencyContactItem[i].email = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="number-field" className="form-label">
                                        Posisi{" "}
                                      </Label>
                                      <Input
                                        name={`agencyContactItem.${i}.position`}
                                        className="form-control"
                                        placeholder="Isi Posisi"
                                        type="text"
                                        value={agencyContactItem[i].position ?? ""}
                                        onChange={(e) => {
                                          validation.setFieldValue(`agencyContactItem.${i}.position`, e.target.value);
                                          agencyContactItem[i].position = e.target.value;
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <Button
                                  className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                  style={{
                                    width: "70px",
                                  }}
                                  onClick={() => {
                                    setAgencyContactItem((val) => [...val.slice(0, i), ...val.slice(i + 1)]);
                                    // let data = cellProps.row.original;
                                    // onClickDelete(data);
                                  }}
                                >
                                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                </Button>
                              </div>
                            );
                          })}
                          <div className="mb-3 position-relative">
                            <Label htmlFor="agencies_contact" className="form-label">
                              Gambar
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success position-absolute top-50 end-0 translate-middle-y"
                              onClick={() => {
                                setMediaType("image");
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {validation.values.image !== "" ? (
                            <div className="border-bottom mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                  <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>

                                <div className="text-truncate">{validation.values.image}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      // e.stopPropagation();
                                      validation.setFieldValue("image", "");
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Mitra"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <Accordion id="default-accordion-example" flush open={open} toggle={toggleAccordion}>
                    <AccordionItem>
                      <AccordionHeader targetId="1" className="accordion-header" id="headingOne">
                        GENERAL INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    Agency Contact
                                  </td>
                                </tr>
                                {info.agency_contact ? (
                                  info.agency_contact.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Name</td>
                                          <td className="p2">{row.name ? row.name : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Email</td>
                                          <td className="p2">{row.email ? row.email : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Phone</td>
                                          <td className="p2">{row.phone ? row.phone : "-"}</td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <tbody>
                                <tr>
                                  <td className="p2 p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                    INFORMASI ALAMAT
                                  </td>
                                </tr>
                                {info.agency_address ? (
                                  info.agency_address.map((row) => {
                                    return (
                                      <Fragment key={row.id}>
                                        <tr>
                                          <td className="p2">Address</td>
                                          <td className="p2">
                                            {row.village ? row.village : "-"}, {row.city ? row.city : "-"}, {row.district ? row.district : "-"}, {row.province ? row.province : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2">Street</td>
                                          <td className="p2">
                                            {row.description ? row.description : "-"} - {row.code ? row.code : "-"}{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="p2" colSpan={"2"}></td>
                                        </tr>
                                      </Fragment>
                                    );
                                  })
                                ) : (
                                  <tr></tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="2" className="accordion-header" id="headingTwo">
                        OTHER CONTACT INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="2">
                        <div className="col-lg-12">
                          {(info.agency_contact || []).map((row) => {
                            return (
                              <table className="table border table-responsive table-striped fs-13 mb-3" key={row.id}>
                                <tbody>
                                  <tr>
                                    <td className="p2">Name</td>
                                    <td className="p2">{row.name ? row.name : "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Position</td>
                                    <td className="p2">{row.position ? row.position : "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Email</td>
                                    <td className="p2">{row.email ? row.email : "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="p2">Phone</td>
                                    <td className="p2">{row.phone ? row.phone : "-"}</td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })}
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionHeader targetId="3" className="accordion-header" id="headingThree">
                        OTHER INFORMATION
                      </AccordionHeader>
                      <AccordionBody accordionId="3">
                        <table className="table table-responsive table-striped fs-12">
                          <tbody>
                            <tr>
                              <td className="p2">Dibuat Oleh</td>
                              <td className="p2">{info.agency_createdby && info.agency_createdby.name ? info.agency_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Diedit Oleh</td>
                              <td className="p2">{info.agency_updatedby && info.agency_updatedby.name ? info.agency_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p2">Approved By</td>
                              <td className="p2">{info.agency_approvedby && info.agency_approvedby.name ? info.agency_approvedby.name + " - " + handleValidDate(info.approvedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Agency.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Agency));
